import React from 'react';

export const SellAnyFooterLogo: React.FC<React.ImgHTMLAttributes<HTMLImageElement>> = (props) => (
  <img loading="lazy" src="/logo.jpg" 
    alt="SellAny Logo"
    className="h-10 w-auto"
    {...props} 
  />
);